/**
 * This file shares code between server and client. Only serializable functions (e.g. no circular refs), without references to PhaserJS
 * or other client-only dependencies should be added here
 */

export function isAnonPlayer(name) {
  const first = name.substring(0, 4);
  const second = name.substring(4);
  if (!first || first !== 'Anon') {
    return false;
  }
  if (!second || second.length !== 6) {
    return false;
  }
  return true;
}

export function logicIndexToSpriteIndex(logicIndex) {
  return ((Math.floor(logicIndex / 18) - 1) / 2) * 18 + ((logicIndex - 1) % 18);
}

export function spriteIndexToLogicIndex(spriteIndex) {
  return Math.floor(spriteIndex / 18) * 2 * 18 + (spriteIndex % 18) + 19;
}

//random min and max inclusive
export function rand(min, max) {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min + 1)) + min;
}
